import { render } from "./FieldsList.vue?vue&type=template&id=6ecb4651&scoped=true"
import script from "./FieldsList.vue?vue&type=script&lang=js"
export * from "./FieldsList.vue?vue&type=script&lang=js"

import "./FieldsList.vue?vue&type=style&index=0&id=6ecb4651&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ecb4651"]])

export default __exports__